import { render } from "./DrawingsPanel.vue?vue&type=template&id=0a8dfed4&scoped=true&ts=true"
import script from "./DrawingsPanel.vue?vue&type=script&lang=ts"
export * from "./DrawingsPanel.vue?vue&type=script&lang=ts"

import "./DrawingsPanel.vue?vue&type=style&index=0&id=0a8dfed4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8dfed4"]])

export default __exports__